import React from 'react'
import styled from 'styled-components'
import Box, { BoxProps } from '@ui/Box'
import routes from '@routes'
import Link from 'next/link'

const NoCard = styled.div`
  color: #9b9b9b;
  font-size: 14px;
  text-align: center;
  margin-top: 16px;
`

const Btn = styled(Link)`
  display: inline-block;
  border-radius: 10px;
  background: transparent;
  padding: 22px 40px;
  border: 1px solid #40e0ec;
  color: #40e0ec;
  cursor: pointer;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;

  &:active:after {
    background: transparent;
  }

  &:hover {
    color: #000;
    background: #40e0ec;
  }
`

interface Props extends BoxProps {
  className?: string
  onClick?: () => void
  noMessage?: boolean
  label?: React.ReactNode
  message?: string
  href: string
  prefetch?: boolean
}

const HelpCentreButton = ({
  className,
  onClick,
  noMessage,
  label = <>Check it out</>,
  href,
  prefetch = true,
  ...props
}: Props) => {
  return (
    <>
      <Box mt={100} className={className} {...props}>
        <Btn onClick={onClick} href={href} prefetch={prefetch}>
          {label}
        </Btn>
      </Box>
    </>
  )
}

export default HelpCentreButton
